import React from 'react'
import { useLocation } from 'react-router-dom'
import { getPermissionActiveMenu } from './app.utils'
import { KEY_STORAGE } from 'constants/common'

const permissionMenus = () => {
  return getPermissionActiveMenu() || {}
}

export const useQuery = () => {
  const { search } = useLocation()

  return React.useMemo(() => new URLSearchParams(search), [search])
}

export const isCreate = () => {
  const permission: any = permissionMenus()
  return {
    style: permission?.isCreate === 1 || permission?.isCreate === undefined ? 'create' : 'disable',
    val: permission?.isCreate || permission?.isCreate === undefined ? permission.isCreate : 0,
    disabled: permission?.isCreate || permission?.isCreate === undefined ? false : true,
  }
}
export const isDelete = () => {
  const permission: any = permissionMenus()

  return {
    style: permission?.isDelete === 1 || permission?.isDelete === undefined ? 'delete' : 'disable',
    val: permission?.isDelete || permission?.isDelete === undefined ? permission.isDelete : 0,
    disabled: permission?.isDelete || permission?.isDelete === undefined ? false : true
  }
}
export const isExport = () => {
  const permission: any = permissionMenus()

  return {
    style: permission?.isExport === 1 || permission?.isExport === undefined ? 'export' : 'disable',
    val: permission?.isExport || permission?.isExport === undefined ? permission.isExport : 0,
    disabled: permission?.isExport || permission?.isExport === undefined ? false : true
  }
}
export const isUpdate = () => {
  const permission: any = permissionMenus()

  return {
    style: permission?.isUpdate === 1 || permission?.isUpdate === undefined ? 'update' : 'disable',
    val: permission?.isUpdate || permission?.isUpdate === undefined ? permission.isUpdate : 0,
    disabled: permission?.isUpdate || permission?.isUpdate === undefined ? false : true
  }
}

export const isView = () => {
  const permission: any = permissionMenus()

  return {
    style: permission?.isView === 1 || permission?.isView === undefined ? 'view' : 'disable',
    val: permission?.isView || permission?.isView === undefined ? permission.isView : 0,
    disabled: permission?.isView || permission?.isView === undefined ? false : true
  }
}

export const isCopy = () => {
  const permission: any = permissionMenus()

  return {
    style: permission?.isCopy === 1 || permission?.isCopy === undefined ? 'copy' : 'disable',
    val: permission?.isCopy || permission?.isCopy === undefined ? permission.isCopy : 0,
    disabled: permission?.isCopy || permission?.isCopy === undefined ? false : true
  }
}
